import React, { useEffect } from "react";
import StoriesTapsCharts from "./StoriesTapsCharts";
import NoData from "../NoData/NoData";
import Loading from "../Loading/Loading";

function StoriesTaps(props) {
    const firstChartLoading = props.chartDataLoading?.insta_story_by_taps;
    const isNoData = props.pageStatus || props.chartData?.insta_story_by_taps?.nodata;
    useEffect(() => {
        props.setIsNoDataState(isNoData);
    }, [props.chartData, props.pageStatus]);
    return (
        <>
            {firstChartLoading && <Loading />}
            {!isNoData && !firstChartLoading && (
                <StoriesTapsCharts
                    chartData={props.chartData}
                    showLegend={props.showLegend}
                    showGridLines={props.showGridLines}
                    showLabel={props.showLabel}
                    graphType={props.graphType}
                    isIGPage={props.isIGPage}
                    widgetContainerRef={props.widgetContainerRef}
                />
            )}
            {isNoData && !firstChartLoading && <NoData message={props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />}
        </>
    );
}
export default StoriesTaps;
